<!-- 数字输入框 -->
<template>
  <div>
    <div v-if="mode === 'DESIGN'" class="input-con max-width">
      <el-input size="small" class="disabled-box" :placeholder="placeholder" type="number"  :maxlength="50" show-word-limit />
      <span v-if="unit" class="unit">{{ unit }}</span>
    </div>
    <template v-else >
      <div v-if="!readerMode || perm==='E'" class="input-con input-con-number max-width">
        <el-input-number style="width: 100%;" :min="0" controls-position="right" :precision="precision" size="small" clearable v-model="_value" :disabled="perm==='R'" :placeholder="placeholder"/>
        <span v-if="unit" class="unit">{{ unit }}</span>
      </div>

      <!-- <el-input v-if="!readerMode" v-model="_value" size="small" :placeholder="placeholder" type="number"/> -->
      <div v-else class="form-item-text">
         {{ _value }}<template v-if="unit">{{ unit }}</template>
      </div>
       <!-- <div  v-else  class="input-con input-con-number input-con-number-dis ">
          <el-input  v-model="_value" size="small" :placeholder="placeholder" type="number" disabled/>
          <span v-if="unit" class="unit">{{ unit }}</span>
       </div> -->
      
    </template>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "NumberInput",
  components: {},
  props:{
    value:{
      type: Number,
      default: null
    },
    precision:{
      type: Number,
      default: 0
    },
    unit:{
      type: String,
      default: ''
    },
    placeholder:{
      type: String,
      default: '请输入数字'
    },
    readerMode: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.max-width{
  max-width: 208px;
}
.w-220{
  // width: 220px;
  width: 100%;
  max-width: 220px;
}
.input-con {
  position: relative;
  .unit {
    position: absolute;
    right: 8px;
    top: 0;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #c5c9c9;
  }
}
.input-con-number{
  line-height: 32px;
  display: inline-block;
  /deep/.el-input-number .el-input__inner{
    text-align: left;
  }
  .unit{
    right: 45px;
    // line-height: 44px;
    // height: 44px;
  }
}
.input-con-number-dis{
  .unit{
    right: 8px;
  }
}
</style>
